export const FALLBACK_KEYWORD_OPTIONS = ["Top", "Best", "Most Recommended"];

export const resolveDefaultKeywordOptions = (customerUiInfo) =>
    customerUiInfo?.rankAttribute ?? FALLBACK_KEYWORD_OPTIONS;

const TRUST_ENGINE_EMAIL = "trustengine@yopmail.com";
const TRUST_ENGINE_TEST_EMAIL = "trustenginetest@yopmail.com";
const TRUST_ENGINE_MAX_KEYWORDS = 10;

// Test account gets a hardcoded keyword cap, independent of the configured attribute list.
export const resolveMaxKeywords = (userEmail, keywordOptionsLength) =>
    userEmail?.toLowerCase() === TRUST_ENGINE_EMAIL || userEmail?.toLowerCase() === TRUST_ENGINE_TEST_EMAIL
        ? TRUST_ENGINE_MAX_KEYWORDS
        : keywordOptionsLength;
